import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AppButton from '../../shared/components/app-button/AppButton';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';

function OtpVerificationModal({ mobileNumber, onVerifyOtp, onResend }) {
  // const [emailOtp, setEmailOtp] = useState('');
  const [mobileOtp, setMobileOtp] = useState('');
  return (
    <div className="d-flex flex-column ">
      {/* <div className="mb-3">
        <div className="mb-2">
          Otp send on <span className="primary-color">{email} </span>
        </div>
        <AppTextInput
          required
          name="email_otp"
          id="email_otp"
          label="Email OTP"
          className="w-100"
          value={emailOtp}
          onChange={(e) => setEmailOtp(e.target.value)}
        />
        <small className="validation-error" />
      </div> */}
      <div className="mb-3">
        <div className="mb-4">
          Registration OTP has been sent to your mobile number{' '}
          <span className="primary-color fw-500">{mobileNumber} </span>
        </div>
        <AppTextInput
          name="mobile_otp"
          id="mobile_otp"
          label="Mobile OTP"
          className="w-100"
          value={mobileOtp}
          maxLength="6"
          onChange={(e) => setMobileOtp(e.target.value)}
        />
        <small className="validation-error" />
        <button
          type="button"
          onClick={onResend}
          className="m-1 onclick-text app-link-purple  float-right"
        >
          Resend
        </button>
      </div>
      <AppButton
        onClick={() => onVerifyOtp(mobileOtp)}
        btnText="Verfiy"
        type="submit"
        className="px-5"
      />
    </div>
  );
}

OtpVerificationModal.propTypes = {
  mobileNumber: PropTypes.string.isRequired,
  onVerifyOtp: PropTypes.func.isRequired,
  onResend: PropTypes.func.isRequired,
};

export default OtpVerificationModal;
